import React from "react";
import { useLanguage } from "../i18n/LanguageProvider";

export default function RulesDisclaimer({ variant = "dark" }) {
  const { t } = useLanguage();
  const isLight = variant === "light";

  return (
    <div
      style={{
        marginTop: 4,
        padding: isLight ? "12px 13px" : "14px 16px",
        borderRadius: isLight ? 12 : 16,
        background: isLight
          ? "rgba(0,0,0,0.055)"
          : "linear-gradient(135deg, rgba(255,255,255,0.075) 0%, rgba(255,255,255,0.035) 100%)",
        border: isLight
          ? "1px solid rgba(0,0,0,0.10)"
          : "1px solid rgba(255,255,255,0.14)",
        color: isLight ? "#111" : "rgba(255,255,255,0.86)",
        boxShadow: isLight
          ? "inset 0 1px 0 rgba(255,255,255,0.45)"
          : "inset 0 1px 0 rgba(255,255,255,0.08)",
      }}
    >
      <div
        style={{
          fontWeight: 1000,
          fontSize: isLight ? 11 : 12,
          letterSpacing: 0.8,
          textTransform: "uppercase",
          marginBottom: 8,
          color: isLight ? "rgba(0,0,0,0.72)" : "rgba(255,255,255,0.7)",
        }}
      >
        {t("rulesDisclaimer.title")}
      </div>
      <p
        style={{
          margin: 0,
          fontSize: isLight ? 12 : 13,
          lineHeight: 1.5,
          fontWeight: isLight ? 800 : 750,
          whiteSpace: "pre-line",
        }}
      >
        {t("rulesDisclaimer.text")}
      </p>
    </div>
  );
}
